import { SEO } from "./SEO";
import { Reveal, Overline } from "./Reveal";

export const LegalLayout = ({ title, updated, path, description, children }) => (
  <>
    <SEO title={title} description={description} path={path} />
    <section className="bg-navy">
      <div className="mx-auto max-w-4xl px-5 pb-14 pt-32 lg:px-8">
        <Overline className="text-accent">Legal</Overline>
        <h1 className="mt-3 font-display text-4xl font-black tracking-tighter text-white sm:text-5xl">
          {title}
        </h1>
        <p className="mt-3 text-sm text-slate-300">Last updated: {updated}</p>
      </div>
    </section>
    <article className="mx-auto max-w-4xl px-5 py-14 lg:px-8">
      <Reveal>
        <div className="legal-prose space-y-6 text-slate-600">{children}</div>
      </Reveal>
    </article>
  </>
);

export const LegalSection = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="font-display text-2xl font-bold tracking-tight text-navy">{heading}</h2>
    <div className="space-y-3 leading-relaxed">{children}</div>
  </section>
);
